import React  from 'react';
import { List, Segment, Rating, Table, Button, Image, Header, Card} from 'semantic-ui-react';
import { Link } from "react-router-dom";
 
//import '../../App.css';


const Resena=({ margenes, opinion,  strings})=>{

 
     
	return (
        <Segment basic style={margenes}>
        <Header as='h2' dividing>
            {strings?strings["Resena"]:""}
        </Header>
        
             <Table basic='very'>
    
        
    <Table.Body>
        
        
         {opinion!=null && opinion.length>0?
            <>
            {opinion.map(op=>(
                <Table.Row>
                <Table.Cell textAlign="center">
                    <Image src='/images/usuarioAvatar.png' size='tiny' circular />
                </Table.Cell>
                <Table.Cell>
                  <Rating icon='star' rating={op.calificacion} maxRating={5} />
                </Table.Cell>

                <Table.Cell>
                    {op.descripcion}
                </Table.Cell>
              </Table.Row>
    
    
            ))}
            </>
        :
        
                    <Table.Row>
                <Table.Cell textAlign="center">
                    <Image src='/images/usuarioAvatar.png' size='tiny' circular />
                </Table.Cell>
                <Table.Cell>
                 
                </Table.Cell>

                <Table.Cell>
                    {strings?strings["SinResena"]:""}
                </Table.Cell>
              </Table.Row>
        
        }
        
        
      
        
        
    </Table.Body>
  </Table>

     
        </Segment>
	);
};



export default Resena;